import { createResource } from '../core'
import { projectMappingsService } from './project-mappings.service'

/** TanStack Query for project teams: `useAllProjectMappings({ projectId })` is the people on one project, grouped by account. */
export const projectMappings = createResource('project-mappings', projectMappingsService)

export const projectMappingsKeys = projectMappings.keys
export const projectMappingsQueries = projectMappings.queries
export const useProjectMappings = projectMappings.useList
export const useAllProjectMappings = projectMappings.useAll
export const useProjectMapping = projectMappings.useOne
export const useCreateProjectMapping = projectMappings.useCreate
export const useUpdateProjectMapping = projectMappings.useUpdate
export const useDeleteProjectMapping = projectMappings.useRemove
